import { cloneElement } from 'react';
import type { ReactElement } from 'react';

import { usePopOverContext } from '../PopOverContext';

export interface PopOverTriggerProps {
  /** 단일 ReactElement — onClick, ref, aria 속성이 자동 주입됩니다. */
  children: ReactElement;
}

export const PopOverTrigger = ({ children }: PopOverTriggerProps) => {
  const { open, contentId, toggle, triggerRef } = usePopOverContext();

  const handleClick = (e: React.MouseEvent) => {
    const childOnClick = (children.props as { onClick?: (e: React.MouseEvent) => void }).onClick;
    childOnClick?.(e);
    if (!e.defaultPrevented) {
      toggle();
    }
  };

  return cloneElement(children, {
    ref: triggerRef,
    onClick: handleClick,
    'aria-expanded': open,
    'aria-haspopup': 'dialog' as const,
    'aria-controls': open ? contentId : undefined,
  });
};

PopOverTrigger.displayName = 'PopOver.Trigger';
